
import WifiNetworks from 'src/components/WifiNetworks'

const Page = () => {

  return (
    <>
      <WifiNetworks />
    </>
  )
}

export default Page
